import React, { Component } from "react";
import Swal from "sweetalert2";
import Axios from "axios";
import { configuration } from "../appConfig";
import { connect } from "react-redux";
import ReportHeader from "./common/ReportHeader";
import PageNo from "./common/PageNo";
import ReportFooter from "./common/ReportFooter";
import PlotDentOnExtraImage from "./PlotDentOnImage/PlotDentOnExtraImage";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class ExtraImages extends Component {
  state = {
    words: {},
    lang: "En",
    selectedFile: "",
    order: {
      vinNumber: "",
      orderNumber: Math.round(Math.random() * 100000000),
      issuedOn: new Date(),
    },
    partDetails: null,
    twoDView: true,
    vinNumber: null,

    extraImages: [],
    showTwoDView: true,
    selectedPartInfo: [],
    scanresult: [],
    extTmage: "",
  };
  componentDidMount() {
    const selectedFile = localStorage.getItem("selectedFile");
    this.setState({ vinNumber: selectedFile });
    // this.getData(selectedFile);
    this.extraImages();
    this.getLang();
  }
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;

    return words[word] ? words[word][lang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    //alert(nextProps.lang+"123")
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  extraImages = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");

    const url = configuration.getExtraImages;
    if (partnerId) {
      const response = await Axios.get(
        url + "?vin=" + selectedFile + "&partnerId=" + partnerId
      );
      if (response.data && response.data.length) {
        this.setState({
          extraImages: response.data,
        });
      } else {
        // alert('Data not available.')
      }

      //console.table(response.data);
    } else {
      this.props.history.push("/login");
    }
  };

  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };

  uploadExtraImages = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");

    const data = new FormData();
    data.append("img", this.state.extTmage);
    data.append("vin", vin);
    data.append("partnerId", partnerId);
    const uploadExtraImages = configuration.uploadExtraImages;

    Axios.post(uploadExtraImages, data)
      .then((res) => {
        Toast.fire({
          type: "success",
          title: "Image Uploaded successfully",
        });
        this.setState({ extTmage: "" });
        window.location.reload(false);
      })
      .catch((err) => {
      });
  };
  delete = (id) => {
    const url = configuration.deleteCommon;
    const confirm = window.confirm("Are you sure want to delete this ?");
    const data = new FormData();
    data.append("id", id);
    // data.append("tblName", "vinimages");
    if (confirm) {
      Axios.post(url, data)
        .then((res) => {
          Toast.fire({
            type: "success",
            title: "Deleted successfully",
          });
          // this.setState({ extTmage: '' });
          window.location.reload(false);
        })
        .catch((err) => {
        });
    }
  };

  render() {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");

    //const {  orderNumber,  } = this.state.order;

    //const dentInfo = scanResult.resultTXT;

    return (
      <React.Fragment>
        {/* {this.state.extraImages.length} */}
        {/* <div className="card-header">Extra Images</div> */}

        {this.state.extraImages.map((r, i) => (
          <React.Fragment key={i}>
            {/* {i%2&&(<div className="newFormatReport" >)} */}
            <div className="newFormatReport">
              {/* <ReportHeader /> */}

              <div style={{ textAlign: "center", fontWeight: "bold" }}>
                {r.comment}
              </div>
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  textAlign: "center",
                }}
              >
                <PlotDentOnExtraImage
                  part={r.name}
                  vin={vin}
                  partnerId={partnerId}
                  imgPath={
                    configuration.imagePath +
                    "/scanImages/" +
                    partnerId +
                    "/" +
                    vin +
                    "/" +
                    r.name
                  }
                  controls={false}
                  // id={id}
                />

                <div className="d-block">
                  <span style={{ color: "red" }}>A:Previous Damage </span>|
                  <span style={{ color: "orange" }}>B: Parking Damage </span> |
                  <span style={{ color: "green" }}>C: Other Damage </span>
                </div>
                {/* <img
                  alt={r.name}
                  src={
                    configuration.imagePath+"/scanImages/" +
                    partnerId +
                    "/" +
                    vin +
                    "/" +
                    r.name
                  }
                  width="100%"
                  style={{ width: 600, height: 500 }}
                  onClick={() => alert()}
                /> */}
              </div>
              <br />
              <br />
              <div>
                {/* <PageNo carNo={this.props.carNo} /> */}

                {/* <ReportFooter /> */}
              </div>
            </div>
            {/* {i%2&&(<div/>)} */}
            {/* <div className="d-print-none h-border"></div> */}
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(ExtraImages);
